/**
 * Use Case: Fetch Dashboard
 * Business logic for fetching dashboard data
 */

import type { FetchDashboardModel } from '../model/DashboardModel';
import type { IDashboardRepository } from '../repository/IDashboardRepository';
import { container, TYPES } from '../../di/DashboardModule';

export const FetchDashboardUseCase = async (): Promise<FetchDashboardModel> => {
  const repository = container.get<IDashboardRepository>(TYPES.IDashboardRepository);
  return repository.fetchDashboard();
};

